(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbUserGroupFilterService',
		[
			'smbSortService',
			'smbContentTypeAcls',
			UserGroupFilterService
		]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbUserGroupFilterService
	 * 
	 * @description
	 * A service that exposes methods for extracting content type group assignment details.
	 */
	function UserGroupFilterService(smbSortService, smbContentTypeAcls) {
		var _userGroupsWithViewRights = [];
		var _userGroupsWithFullRights = [];
		var _userGroupsWithEditRights = [];

		return {
			/**
			 * @ngdoc method
			 * @name smbUserGroupFilterService#filterUserGroups
			 * @methodOf smb-app.smbUserGroupFilterService
			 * @kind function
			 * 
			 * @description
			 * Filters and separates User Groups into two lists, one with View rights and Full rights
			 * 
			 * @param {Object} details, The details object from wchich the details have to be extracted
			 */
			filterUserGroups: filterUserGroups,

			getUserGroupsWithViewRights: getUserGroupsWithViewRights,

			getUserGroupsWithFullRights: getUserGroupsWithFullRights,

			getUserGroupsWithEditRights: getUserGroupsWithEditRights,
		};

		function filterUserGroups(details) {
			_userGroupsWithViewRights = [];
			_userGroupsWithFullRights = [];
			_userGroupsWithEditRights = [];

			details.forEach(function (permission) {
				if (permission.UserGroupId > 0)
				{
					switch (permission.Privileges) {
						case smbContentTypeAcls.VIEW_RIGHTS:
							_userGroupsWithViewRights.push(permission);
							break;
						case smbContentTypeAcls.EDIT_RIGHTS:
							_userGroupsWithEditRights.push(permission);
							break;
						case smbContentTypeAcls.FULL_RIGHTS:
							_userGroupsWithFullRights.push(permission);
							break;
					}
				}
			});

			_userGroupsWithViewRights.sort(smbSortService.sortObjectByStringProperty('UserGroupName'));
			_userGroupsWithFullRights.sort(smbSortService.sortObjectByStringProperty('UserGroupName'));
			_userGroupsWithEditRights.sort(smbSortService.sortObjectByStringProperty('UserGroupName'));
		}

		function getUserGroupsWithEditRights() {
			return _userGroupsWithEditRights;
		}

		function getUserGroupsWithViewRights() {
			return _userGroupsWithViewRights;
		}

		function getUserGroupsWithFullRights() {
			return _userGroupsWithFullRights;
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/userGroupFilterService.js
// module id = 162
// module chunks = 1